module.exports = __webpack_public_path__ + "static/media/invoiceNormal.b93c08d5.svg";